import axiosService from './common/axiosReport'
import axios from 'axios'
import qs from "qs"

function fetchClassification(query){
  return axiosService.get('portal/class/search',  {params: query})	
}
function fetchSearchReportList(query){
  return axiosService.get('portal/report/search', {params: query, paramsSerializer: params => qs.stringify(params, { indices: false })})
}
function fetchSearchReportDetail(query){
  return axiosService.get('portal/report/search/detail',  {params: query})	
}

function loadImage(fileId) {
  return axiosService.get('file/image', { params: { fileId }, responseType: 'blob'})
}

export function fileDownload(fileId, showFileName) {
  const axiosService = axios.create({
    baseURL: process.env.VUE_APP_REPORT_SERVER + '/api/'
  })

  axiosService.get('file/download', {
    responseType: 'blob',
    headers: {responseType: 'arraybuffer'},
    params: { fileId: fileId }
  }).then(res => {
    let blob = new Blob([res.data], {type: res.headers['content-type']})
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    const contentDisposition = res.headers['Content-Disposition']
    let fileName = ''

    if (contentDisposition) {
      const [fileNameMatch] = contentDisposition.split(';').filter(str => str.includes('filename'))
      if (fileNameMatch)
        [, fileName] = fileNameMatch.replace(/"/g, '').split('=');
    }
    fileName = decodeURI(fileName)

    if (window.navigator.msSaveOrOpenBlob) { // IE 10+
      window.navigator.msSaveOrOpenBlob(blob, showFileName)
    } else { // not IE
      link.href = url
      link.setAttribute('download', showFileName)
      document.body.appendChild(link)
      link.click()
    }
  }).catch(error => {
    alert('다운로드 중 오류가 발생했습니다.')
  })
}

export function pdfFileDownload(fileId, showFileName) {
  const axiosService = axios.create({
    baseURL: process.env.VUE_APP_REPORT_SERVER + '/api/'
  })

  axiosService.get('file/download/pdf', {
    responseType: 'blob',
    headers: {responseType: 'arraybuffer'},
    params: { fileId: fileId }
  }).then(res => {
    let blob = new Blob([res.data], {type: res.headers['content-type']})
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    const contentDisposition = res.headers['Content-Disposition']
    let fileName = ''

    if (contentDisposition) {
      const [fileNameMatch] = contentDisposition.split(';').filter(str => str.includes('filename'))
      if (fileNameMatch)
        [, fileName] = fileNameMatch.replace(/"/g, '').split('=');
    }
    fileName = decodeURI(fileName)

    if (window.navigator.msSaveOrOpenBlob) { // IE 10+
      window.navigator.msSaveOrOpenBlob(blob, showFileName)
    } else { // not IE
      link.href = url
      link.setAttribute('download', showFileName)
      document.body.appendChild(link)
      link.click()
    }
  }).catch(error => {
    alert('다운로드 중 오류가 발생했습니다.')
  })
}

export function fileLoad(fileId, testFileName) {
  const axiosService = axios.create({
    baseURL: process.env.VUE_APP_REPORT_SERVER + '/api/'
  })

  axiosService.get('file/download', {
    responseType: 'blob',
    headers: {responseType: 'arraybuffer'},
    params: { fileId: fileId }
  }).then(res => {
    let blob = new Blob([res.data], {type: res.headers['content-type']})
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    const contentDisposition = res.headers['Content-Disposition']
    let fileName = ''

    if (contentDisposition) {
      const [fileNameMatch] = contentDisposition.split(';').filter(str => str.includes('filename'))
      if (fileNameMatch)
        [, fileName] = fileNameMatch.replace(/"/g, '').split('=');
    }
    fileName = decodeURI(fileName)

    if (window.navigator.msSaveOrOpenBlob) { // IE 10+
      window.navigator.msSaveOrOpenBlob(blob, testFileName)
    } else { // not IE
      link.href = url
      link.setAttribute('download', testFileName)
      document.body.appendChild(link)
      window.open(url, name);

    }
  }).catch(error => {
    alert('다운로드 중 오류가 발생했습니다.')
  })
}

export function fileLinkUrl(fileId) {
  const baseURL = process.env.VUE_APP_REPORT_SERVER + '/api/'
  const fileDownloadURL = 'file/download/pdf'

  return baseURL + fileDownloadURL + '?fileId=' + fileId
}
export { fetchClassification, fetchSearchReportList, fetchSearchReportDetail, loadImage}
